import { Component, OnInit, Inject, Optional, AfterViewInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiServiceService } from 'src/app/api-service.service';

@Component({
    selector: 'app-referral-modal',
    templateUrl: './referral-modal.component.html',
    styleUrls: ['./referral-modal.component.scss'],
    standalone: false
})
export class ReferralModalComponent implements OnInit, AfterViewInit {

  referral_agency = new UntypedFormGroup({
    company_id: new UntypedFormControl('', Validators.required),
    agent_name: new UntypedFormControl('')
  });

  agencies: any;
  constructor(public dialogRef: MatDialogRef<ReferralModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private apiService: ApiServiceService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.apiService.rapidReferralAgencies().subscribe(res => {
      this.agencies = res;
    })
  }

  onOK() {
    this.dialogRef.close(this.referral_agency.value);
  }

}

